/**
 * @author Ariel
 * @date 2020-08-25
 * @desc 应用服务查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
const { WizContainer, modelUtils } = framework_tool;
const { WizCard } = component_tool;
const { Session } = utils_tool


class ApplicationManageLook extends WizContainer {
  componentName = 'applicationManageLook'
  constructor(props){
    super(props)
    const {history} = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/application/applicationManage/applicationManageLook') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('detailInfo',detailInfo)
      } else {
        detailInfo = Session.get('detailInfo') || {}
      }
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
  }

  _render() {
    const items = this.detailInfo
    items['sourceType'] == 0 ? items['sourceType'] = "新培训平台" : items['sourceType'] = "第三方系统"
    items['status'] == 0 ? items['status'] = "禁用" : items['status'] = "启用"
    items['monitorStatus'] == 0 ? items['monitorStatus'] = "禁用" : items['monitorStatus'] = "启用"

    return (
      <React.Fragment>
        <WizCard>
          <Descriptions bordered column={{xs: 1, sm: 1, md: 2}} style={{ paddingLeft: 25 }}>
            <Descriptions.Item label='应用服务'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='所属组织'>{items.orgName}</Descriptions.Item>
            <Descriptions.Item label='来源'>{items.sourceType}</Descriptions.Item>
            <Descriptions.Item label='应用服务编号'>{items.code}</Descriptions.Item>
            <Descriptions.Item label='负责人'>{items.principalName}</Descriptions.Item>
            <Descriptions.Item label='联系电话'>{items.principalPhone}</Descriptions.Item>
            <Descriptions.Item label='Key'>{items.privateKey}</Descriptions.Item>
            <Descriptions.Item label='密钥'>{items.secretKey}</Descriptions.Item>
            <Descriptions.Item label='状态'>{items.status}</Descriptions.Item>
            <Descriptions.Item label='监控状态'>{items.monitorStatus}</Descriptions.Item>
            <Descriptions.Item label='监控url'>{items.monitorUrl}</Descriptions.Item>
            <Descriptions.Item label='监控频率'>{items.monitorFrequency == -1 ? '' : items.monitorFrequency}秒/次</Descriptions.Item>
            <Descriptions.Item label='简介'>{items.intro}</Descriptions.Item>
          </Descriptions>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state,ownProps) => {
  const load = modelUtils.getLoadingState(state,'applicationManage')
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ApplicationManageLook)
